import styled from "styled-components/macro";

export const CSS_TOOLTIP = `
  font-family: 'Open Sans';
  font-size: 14px;

  background-color: white;
  padding: 12px 16px;
  border: 1px solid rgba(222, 222, 222, 1);
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.15);
  border-radius: 4px;

  .tooltip-title,
  .recharts-default-tooltip {
    font-weight: 700;
  }
`;
export const RechartToolTipStyles = styled.div`
  ${CSS_TOOLTIP}
`;
